module.exports = __webpack_public_path__ + "static/downloable/guia-solicitud-de-pensión-de-sobrevivencia.d7b8298.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/guias/guia-solicitud-de-pensión-de-sobrevivencia.pdf
// module id = 4Psj
// module chunks = 1